/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAreaProps } from './translator/area'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchArea, FetchHospitalArea } from '@/infrastructure/network/Monitaro/requests/area'

export default class Area extends MonitaroGatewayBase {
  async FetchArea(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchArea(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.areas.map((prop) => toAreaProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchHospitalArea(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchHospitalArea(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.areas.map((prop) => toAreaProps(prop)),
      query: toQueryProps(response.query)
    })
  }
}
